<template>
  <section class="section">
    <div class="container">
      <div class="columns is-marginless" v-if="!loading&&homeImageDock">
        <div v-for="element in homeImageDock.elements" :key="element.id" class="column">
          <figure class="image">
            <img v-if="element.mainImage" :src="element.mainImage[0].fileUrl" style="object-fit: cover; margin:auto; max-width:80px;max-height:80px">
          </figure>
          <p class="subtitle is-size-6 element-subtitle" v-html="element.shortDescription"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  mounted () {
    return this.getHomeImageDock().catch()
  },
  computed: {
    ...mapState({
      homeImageDock: state => state.CRUD.homeImageDock,
      loading: state => state.CRUD.pending.homeImageDock
    })
  },
  methods: {
    ...mapActions(['getHomeImageDock'])
  }
}
</script>

<style scoped>
.element-subtitle {
  padding-top: 15px !important;
}
</style>
